import { useState } from "react";
import { useStateStore } from "@/store";
import yumiLogoIcon from "./imgs/yumiLogoIcon.svg";
import bityLogoIcon from "./imgs/bityLogoIcon.svg";
import origynLogoIcon from "./imgs/origynLogoIcon.svg";
import shikuLogoIcon from "./imgs/shikuLogoIcon.svg";
import helixLogoIcon from "./imgs/helixLogoIcon.svg";
import archeryLogoIcon from "./imgs/archeryLogoIcon.svg";
import icpGlobalLogoIcon from "./imgs/icpGlobalLogoIcon.svg";
import bochslerLogoIcon from "./imgs/bochslerLogoIcon.svg";
import eterbaLogoIcon from "./imgs/eterbaLogoIcon.svg";
import edgeLogoIcon from "./imgs/edge.svg";
import dracoonLogoIcon from "./imgs/dracoon.svg";
import kebnelIcon from "./imgs/kebnel.svg";
import oneYumiIcon from "./imgs/oneYumiIcon.svg";
import arrow from "./imgs/arrow.svg";
import PlatformLoadingDom from "./components/PlatformLoadingDom";
import PlatformInfoModal from "./components/PlatformInfoModal";
import "./index.scss";

const MeetsCapitalWrap = () => {
  const state = useStateStore();
  const { appType } = state.default;
  const [detailPageFlagPlatformInfoModal, setDetailPageFlagPlatformInfoModal] = useState(false);
  const [platformInfoModalStyle, setPlatformInfoModalStyle] = useState({});
  const [disabledLoadingFlagPlatformInfoModal, setDisabledLoadingFlagPlatformInfoModal] =
    useState(false);
  const [platformRecordIndex, setPlatformRecordIndex] = useState(0);

  const handlePlatformInfoModalStyleToLeft = () => {
    if (!disabledLoadingFlagPlatformInfoModal) {
      setDisabledLoadingFlagPlatformInfoModal(true);
      setDetailPageFlagPlatformInfoModal(true);
      setPlatformInfoModalStyle({
        animation: "platformInfoModalWrapRightToLeft 0.3s ease-in-out forwards",
      });
      setTimeout(() => {
        setDisabledLoadingFlagPlatformInfoModal(false);
      }, 1000);
    }
  };

  const handlePlatformInfoModalStyleToRight = () => {
    if (!disabledLoadingFlagPlatformInfoModal) {
      setDisabledLoadingFlagPlatformInfoModal(true);
      setPlatformInfoModalStyle({
        animation: "platformInfoModalWrapLeftToRight 0.3s ease-in-out forwards",
      });
      setTimeout(() => {
        setDetailPageFlagPlatformInfoModal(false);
        setDisabledLoadingFlagPlatformInfoModal(false);
      }, 1000);
    }
  };

  const handleWindowScroll = () => {
    const blockchainWrapOffsetHeight = document.querySelector(".blockchainWrap").offsetHeight;
    const webSpaceWrapOffsetHeight = document.querySelector(".webSpaceWrap").offsetHeight;
    const meetsCapitalWrapOffsetHeight = document.querySelector(".meetsCapitalWrap").offsetHeight;
    const partnersWrapOffsetHeight = document.querySelector(".partnersWrap").offsetHeight;
    const subscribeWrapOffsetHeight = document.querySelector(".subscribeWrap").offsetHeight;
    const webEventsWrapOffsetHeight = document.querySelector(".webEventsWrap").offsetHeight;
    window.scrollTo(
      0,
      blockchainWrapOffsetHeight +
        webSpaceWrapOffsetHeight +
        meetsCapitalWrapOffsetHeight +
        partnersWrapOffsetHeight +
        subscribeWrapOffsetHeight +
        webEventsWrapOffsetHeight,
    );
  };

  return (
    <>
      <div className="meetsCapitalWrap">
        <div className="comTitle">
          <span className="whiteText">Innovation</span>
          <span className="themeColorText">meets Capital</span>
        </div>
        <div className="infoContent">
          <div className="platformOneTable">
            <div
              className="tableItem border-l-0 border-b-0 border-r-0"
              onClick={() => {
                setPlatformRecordIndex(0);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <div className="firstIcon">
                <img src={oneYumiIcon} alt="" />
              </div>
              <img src={yumiLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-b-0 border-r-0"
              onClick={() => {
                setPlatformRecordIndex(1);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <img src={bityLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-b-0"
              onClick={() => {
                setPlatformRecordIndex(2);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <img src={origynLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-l-0 border-b-0 border-r-0"
              onClick={() => {
                setPlatformRecordIndex(3);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <img style={{ scale: "50%" }} src={require("./imgs/gldtLogoIcon.png")} alt="" />
            </div>
            <div
              className="tableItem border-b-0 border-r-0"
              onClick={() => {
                setPlatformRecordIndex(4);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <img src={shikuLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-b-0"
              onClick={() => {
                setPlatformRecordIndex(5);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <img src={helixLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-l-0 border-r-0"
              onClick={() => {
                setPlatformRecordIndex(6);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <img
                style={{ scale: "50%" }}
                src={require("./imgs/metaversityLogoIcon.png")}
                alt=""
              />
            </div>
            <div
              className="tableItem border-r-0"
              onClick={() => {
                setPlatformRecordIndex(7);
                handlePlatformInfoModalStyleToLeft();
              }}
            >
              <img style={{ scale: "50%" }} src={require("./imgs/dsocialLogoIcon.png")} alt="" />
            </div>
            {appType === "pc" || appType === "pad" ? (
              <div className="tableItemNone">
                <PlatformLoadingDom />
              </div>
            ) : null}
          </div>
          <div className="centerCom">
            <div className="infoText">
              Swiss
              {appType === "phone" ? <br /> : <>&nbsp;</>}
              Blockchain Labs
            </div>
          </div>
          <div className="platformTwoTable">
            <div
              className="tableItem border-r-0"
              onClick={() => {
                window.open("https://archery.fund/");
              }}
            >
              <img src={archeryLogoIcon} alt="" />
            </div>
            <div
              className="tableItem"
              onClick={() => {
                window.open("https://icp.global/home/");
              }}
            >
              <img src={icpGlobalLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-t-0 border-r-0"
              onClick={() => {
                window.open("https://www.bochslerfinance.com/");
              }}
            >
              <img src={bochslerLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-t-0"
              onClick={() => {
                window.open("https://anmicapital.com/");
              }}
            >
              <img style={{ scale: "50%" }} src={require("./imgs/logo_EternaCapital.png")} alt="" />
            </div>
            <div
              className="tableItem border-t-0 border-r-0"
              onClick={() => {
                window.open("https://www.eternacapital.com/");
              }}
            >
              <img src={eterbaLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-t-0"
              onClick={() => {
                window.open("https://edge-ventures.io/");
              }}
            >
              <img src={edgeLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-t-0 border-r-0"
              onClick={() => {
                window.open("https://www.dracoon.ventures/");
              }}
            >
              <img src={dracoonLogoIcon} alt="" />
            </div>
            <div
              className="tableItem border-t-0 border-r-0"
              onClick={() => {
                window.open("http://www.kernel-ventures.com/");
              }}
            >
              <img src={kebnelIcon} alt="" />
            </div>
            {/* {appType === "pc" || appType === "pad" ? (
              <div className="tableItemNone border-t-0">
                <PlatformLoadingDom />
              </div>
            ) : null} */}
          </div>
        </div>
        <div className="joinContent">
          <div
            className="joinBtn"
            onClick={() => {
              handleWindowScroll();
            }}
          >
            <div className="btnText">
              <span>Join to see more</span>
            </div>
            <div className="arrowImg">
              <img src={arrow} alt="" />
            </div>
          </div>
        </div>
      </div>
      {detailPageFlagPlatformInfoModal ? (
        <PlatformInfoModal
          platformRecordIndex={platformRecordIndex}
          platformInfoModalStyle={platformInfoModalStyle}
          handlePlatformInfoModalStyle={handlePlatformInfoModalStyleToRight}
        />
      ) : null}
    </>
  );
};

export default MeetsCapitalWrap;
